import React, { useContext, type JSX } from 'react';
import { IRutinInfo } from '../../../Types/RutinInfoType';
import { IDelsystem } from '../../../Features/Delsystem/_Common/Const/Delsystem';
import { ActiveDatabaseContext } from '../../ActiveDatabaseContext/ActiveDatabaseContext';

export interface IRutinerProps {
  delsystem: IDelsystem;
  dbName?: string;
  children: (availableRoutines: IRutinInfo[]) => JSX.Element;
}

const AvailableRutinerInDelsystem: React.FunctionComponent<
  IRutinerProps
> = props => {
  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  if (!activeDatabaseContext.availableDelsystem) {
    return props.children([]);
  }

  return props.children(
    props.delsystem.rutiner.filter(
      rutin => activeDatabaseContext.availableRoutines?.[rutin.rutinID]
    )
  );
};

export default AvailableRutinerInDelsystem;
